import type { Season, Series } from '../types';

export function getSeriesSeasons(series: Series): Season[] {
  return series.seasons;
}
